import AppsIcon from '@material-ui/icons/Apps';
import GET_PRODUCT_CACHE from 'graph/product-cache/product-cache-query';
import { transformApps, PliManagedApp } from 'store/cache/product-cache';
import { App } from 'types/schema-generated-types';
import { RouteConfig, RouteId, GetBreadcrumbsResponse } from '../../../types';
import AppAccessDetails from '../AppAccessDetails';

const getRoutes = (): RouteConfig[] => {
  const title = 'App Access';
  const routePrefix = '/app-access';

  return [
    {
      Component: AppAccessDetails,
      getTitle: () => title,
      path: `${routePrefix}/:productCodeOrAppName`,
      id: RouteId.APP_ACCESS_APP_DETAILS,
      privileges: [],
      getBreadcrumbs: ({ match, client }): GetBreadcrumbsResponse => {
        const productCodeOrAppName = match?.params?.productCodeOrAppName ?? '';
        const productCode = productCodeOrAppName?.toUpperCase();
        const appName = productCodeOrAppName?.toLowerCase();

        let appTitle = title;
        try {
          const result = client.readQuery<{ apps: App[] }>({
            query: GET_PRODUCT_CACHE
          });

          const apps = transformApps(result?.apps ?? []);
          const app = apps.find(
            (a: PliManagedApp) =>
              a.app.name === appName || a.appProduct?.product?.code === productCode
          );

          if (app?.title) appTitle = app.title;
        } catch {
          // do nothing
        }

        return [
          { name: 'Application Access', path: '/app-access', Icon: AppsIcon },
          { name: appTitle, path: `${routePrefix}/${productCodeOrAppName}` }
        ];
      }
    }
  ];
};

export default getRoutes;
